<template>
    <div v-if="product.available">
        <v-btn
            small
            fab
            text
            icon
            :disabled="!product.available"
            @click.stop="cartClickHandler(product.id)"
        >
            <v-icon color="orange lighten-2">{{ cartIcon }}</v-icon>
        </v-btn>
        <add-to-basket-dialog
            :product="product"
            :is-open="openAddToBasketDialog"
            @close="openAddToBasketDialog = false"
        ></add-to-basket-dialog>
    </div>
</template>

<script>
import AddToBasket from "../../../app-front/mixins/AddToBasket";
import NoLoginBasket from "../../../app-front/mixins/NoLoginBasket";
import ActionAccess from "../../../app-front/mixins/ActionAccess";
import AddToBasketDialog from "../../../app-front/components/dialogs/AddToBasketDialog";
import BasketService from "../../../app-front/services/api/BasketService";


export default {
    name: "ProductActions",
    props: ['product'],
    mixins: [ActionAccess, AddToBasket, NoLoginBasket],
    components: {
      AddToBasketDialog
    },
    data() {
        return {
            openAddToBasketDialog: false
        }
    },
    methods: {
        cartClickHandler() {

            if (this.inBasket) {
                this.$router.push('/basket')
            } else {
                this.openAddDialog();
            }
        },
        openAddDialog(){
            this.openAddToBasketDialog = true;
            //this.authActionHandle({type: 'cart'})
        },
        authSuccessActionHandle() {
            const product = {
                id: this.product.id,
                quantity: 1
            };
            BasketService.updateList([product])
                .then(res => {
                    this.$store.commit('setBasket', res.data);
                })
                .catch(err => {
                    console.log(err)
                });
        },
        noLoginAction(data) {
            if (data.type == 'cart') {
                this.addToNoLoginBasket(this.product.id)
            }
        },
    },
    computed: {
        cartIcon() {
            return this.inBasket ? 'shopping_cart' : 'add_shopping_cart';
        },
        inBasket() {
            return (this.isBasket(this.product.id) || this.isInNoLoginBasket(this.product.id));
        },
    }
}
</script>

<style scoped>

</style>
